module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/common/signin-icon-925051d87c008913c63a4597f4917aed.png";